/**
 * This is a workaround to remove un-wanted dependency introduced by motif.
 * 
 * motif has a dependency to react-pdf library, it is not used in Patient Portal.
 * however motif is distributed as one big javascript file which does not support tree-shaking.
 * in this case, all imports must exists to make the project compile.
 * this file is created to mock the dependency, it can be removed after motif properly support tree-shaking
 */
export default {};
